import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { ApiHandlerService } from '../utils/api-handler.service';
import { API_ENDPOINTS, ApiMethod } from '../utils/const';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { CommonService } from './common.service';
import { ApiService } from './api.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { IaproposalworkorderstatusComponent } from '../../core/components/website/iaproposalworkorderstatus/iaproposalworkorderstatus.component';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private toastrService: ToastrService,
    private router: Router,
    private commonService: CommonService,
    private http: ApiHandlerService,
    private dialogRef: MatDialog,
    private apiService: ApiService) { }


  signIn(data: any) {
    return this.http.requestCall(API_ENDPOINTS.LOGIN.MSME, ApiMethod.POST, '', data)
  }

  resetPassword(data: any, token: any) {
    return this.http.requestCall(API_ENDPOINTS.resetPassword, ApiMethod.POST, token, data)
  }
  forgetPassword(data: any) {
    return this.http.requestCall(API_ENDPOINTS.forgetPassword, ApiMethod.POST, '', data)
  }

  signUp(data: any) {
    return this.http.requestCall(API_ENDPOINTS.SINGUP, ApiMethod.POST, '', data)
  }
  changePasswordMSME(data: any, token: any) {
    return this.http.requestCall(API_ENDPOINTS.CHANGEPASSWORD.MSME, ApiMethod.POST, token, data)
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    var isUserLogin = sessionStorage.getItem('isUserLoggedIn');
    var isAdminLogin = sessionStorage.getItem('isAdminLoggedIn');
    var isApproved = sessionStorage.getItem('isApproved');

    var requiredRole = sessionStorage.getItem('UserType'); // Retrieve the admin role from session storage
    const moduleType = route.data['module'];
    const isVisible = route.data['isVisible'];

    if (isVisible && moduleType == 'MSME' && isUserLogin) {
      return true;
    }

    if (isVisible && moduleType == 'IA' && isUserLogin) {
      return true;
    }

    if (moduleType == 'MSME' && isApproved == 'Approved') {
      return true;
    }
    else if (moduleType == 'MSME') {
      return false;
    }

    if (requiredRole == 'DIC' && isUserLogin) {
      return true;
    }

    if (requiredRole == 'MSSIDC' && isAdminLogin) {
      return true;
    }

    //if (isUserLogin || isAdminLogin) {
    //  return true;
    //}
    //else if (!isUserLogin) {
    //  this.router.navigate(['/login']);
    //  return false;
    //}
    //else {
    //  this.router.navigate(['/login']);
    //  return false;
    //}

    if (moduleType !== "common" && moduleType !== requiredRole) {
      // Clear user session if navigating to admin routes
      sessionStorage.removeItem('isUserLoggedIn');
      sessionStorage.removeItem('authToken');
      sessionStorage.clear();
      this.router.navigate(['/login']);
      return false;
      //// Check if admin is logged in
      //if (isAdminLogin)
      //{
      //  return true;
      //  // Check if the required role matches the admin's role
      //  //if (requiredRole && requiredRole === adminRole)
      //  //{
      //  //  return true;
      //  //} else if (!requiredRole) {
      //  //  return true; // If no specific role is required, allow access
      //  //} else {
      //  //  sessionStorage.removeItem('authToken');
      //  //  sessionStorage.clear();
      //  //  this.router.navigate(['/login']); // Redirect to unauthorized page if roles don't match
      //  //  return false;
      //  //}
      //} else {
      //  sessionStorage.removeItem('authToken');
      //  sessionStorage.clear();
      //  this.router.navigate(['/login']);
      //  return false;
      //}
    }
    //else if (moduleType === 'msme') {
    //  // Clear admin session if navigating to user/website routes
    //  sessionStorage.removeItem('isAdminLoggedIn');

    //  // Check if user is logged in
    //  if (isUserLogin) {
    //    return true;
    //  } else {
    //    sessionStorage.removeItem('authToken');
    //    sessionStorage.clear();
    //    this.router.navigate(['/login']);
    //    return false;
    //  }
    //}
    //else if (moduleType === 'ia') {
    //  // Clear admin session if navigating to user/website routes
    //  sessionStorage.removeItem('isAdminLoggedIn');

    //  // Check if user is logged in
    //  if (isUserLogin) {
    //    return true;
    //  } else {
    //    sessionStorage.removeItem('authToken');
    //    sessionStorage.clear();
    //    this.router.navigate(['/login']);
    //    return false;
    //  }
    //}
    //else {
    //  // Default case if no valid module is provided
    //  sessionStorage.removeItem('authToken');
    //  sessionStorage.clear();
    //  this.router.navigate(['/']);
    //  return false;
    //}
    //return true;
  }
  logout() {
    localStorage.clear();
  }
  hideSubject = new Subject<any>();
  OpenLoginService = new Subject<any>();
  cartSubject = new Subject<any>();

  validateSession() {
    const authToken = sessionStorage.getItem("authToken");
    if (authToken != null) {
      this.apiService.getRequest(API_ENDPOINTS.validationsession).subscribe({
        next: (res) => {
          // Assuming you want to show a message with toastr in case of a response
          this.toastrService.error(res.message);
          this.dialogRef.closeAll();
        },
        error: (err) => {
          // Handle the error, maybe show a general error message
          this.toastrService.error("Internal Server error");
        }
      });
    }
  }
}
